export default {
  hero: {
    title: "Let's Connect",
    subtitle: "Ready to bring your ideas to life?",
    body: "We'd love to hear about your project and explore how we can help you achieve your goals. Drop us a message, and let's start building something amazing together!",
  },
  dialog: {
    successTitle: "Success!",
    errorTitle: "Error",
    successFallback: "Message sent successfully!",
    errorFallback: "Failed to send message. Please try again.",
    networkError:
      "Network error: {{error}}. Please check your connection and try again.",
    ok: "OK",
  },
  form: {
    title: "Send us a Message",
    nameLabel: "Your Name",
    namePlaceholder: "Enter your name",
    emailLabel: "Email Address",
    emailPlaceholder: "Enter your email",
    subjectLabel: "Subject",
    subjectPlaceholder: "What's this about?",
    messageLabel: "Message",
    messagePlaceholder: "Tell us about your project or ask us anything...",
    sending: "Sending...",
    send: "Send Message",
  },
  info: {
    title: "Get in Touch",
    body: "Have a question or want to work together? We'd love to hear from you. Choose your preferred way to connect with us.",
    cards: {
      email: { title: "Email Us", desc: "Send us an email anytime!" },
      phone: { title: "Call Us", desc: "Sat-Thu from 9am to 6pm" },
      location: { title: "Visit Us", desc: "Come say hello at our office" },
    },
    followTitle: "Follow Us",
  },
  faq: {
    title: "Frequently Asked Questions",
    subtitle:
      "Quick answers to common questions about our services and process.",
    items: {
      services: {
        question: "What services do you offer?",
        answer:
          "We specialize in web development, mobile applications, IoT solutions, DevOps, and digital transformation consulting. From concept to deployment, we cover the full development lifecycle.",
      },
      timeline: {
        question: "How long does a typical project take?",
        answer:
          "Project timelines vary based on complexity and scope. Simple websites take 2-4 weeks, while complex applications can take 2-6 months. We'll provide a detailed timeline during consultation.",
      },
      startups: {
        question: "Do you work with startups?",
        answer:
          "Absolutely! We love working with startups and understand the unique challenges you face. We offer flexible pricing and can scale our services as your business grows.",
      },
      process: {
        question: "What's your development process?",
        answer:
          "We follow agile methodologies with regular check-ins, iterative development, and continuous feedback. You'll be involved throughout the process with full transparency.",
      },
      support: {
        question: "Do you provide ongoing support?",
        answer:
          "Yes! We offer comprehensive maintenance and support packages to keep your applications running smoothly and up-to-date with the latest technologies.",
      },
      communication: {
        question: "How do you handle project communication?",
        answer:
          "We maintain open communication through regular meetings, progress reports, and collaborative tools. You'll always know the status of your project.",
      },
    },
  },
};
